import { useOutletContext } from 'react-router-dom';

import ChecklistItemPanel from '../../components/checklist-item-panel/ChecklistItemPanel.js';
import {
    ChecklistDisplayContainer,
    CardItemWrapper,
} from '../../ChecklistDisplay.styles.js';

export default function ChecklistCardListView() {
    const {
        filteredCardIds,
        checklistData,
        collectionData,
        parallelData,
        parallelOptions,
        sortCollectedByDropdownOrder,
        defaultParallel,
    } = useOutletContext();

    /* Drop missing cards before mapping so the index matches the rendered grid position,
       which is what decides whether a panel is in the right-hand column. */
    const visibleCardIds = filteredCardIds.filter((cardId) => !!checklistData[cardId]);

    return (
        <ChecklistDisplayContainer>
            {visibleCardIds.map((cardId, index) => {
                const card = checklistData[cardId];
                const collectedCards = sortCollectedByDropdownOrder(
                    collectionData[cardId]?.collectedCards ?? []
                );
                const cardWithCollected = { ...card, cardId, collectedCards };
                return (
                    <CardItemWrapper key={cardId}>
                        <ChecklistItemPanel
                            card={cardWithCollected}
                            parallels={card.parallels}
                            parallelData={parallelData}
                            parallelOptions={parallelOptions}
                            defaultParallel={defaultParallel}
                            mirrored={index % 2 === 1}
                        />
                    </CardItemWrapper>
                );
            })}
        </ChecklistDisplayContainer>
    );
}
